export const reviews = [
  {
    id: 1,
    review:
      "Cito’s Learners has been amazing for my child. Their confidence in maths and English has grown so much, and the lessons are clear, engaging, and perfectly paced for 11+ preparation.",
  },
  {
    id: 2,
    review:
      "We've had a fantastic experience with Cito’s Learners. The structured approach to Maths and English has really helped my child understand topics more clearly, and their confidence going into the 11+ has improved enormously.",
  },
  {
    id: 3,
    review:
      "Cito’s Learners has made such a positive difference for my child. The lessons are well organised, easy to follow, and keep students engaged while building the key skills needed for the 11+ exams.",
  },
  {
    id: 4,
    review:
      "My child genuinely enjoys the sessions with Cito’s Learners. The teaching style is supportive and encouraging, and we've seen real progress in both Maths and English over the past few months.",
  },
  {
    id: 5,
    review:
      "I’m really impressed with Cito’s Learners. The content is clear and focused on exactly what children need for 11+ preparation. My child feels much more confident tackling exam-style questions now.",
  },
  {
    id: 6,
    review:
      "Cito’s Learners has been a great support during our 11+ journey. The lessons are engaging and well paced, helping my child strengthen their understanding while staying motivated to learn.",
  },
  {
    id: 7,
    review:
      "Since starting with Cito’s Learners, we've noticed a big improvement in our child’s approach to Maths and English. The teaching is clear, the structure works well, and it’s been a very positive experience overall.",
  },
];
